export default "__VITE_ASSET__XK$TWPtz__"